<template>
  <div class="row">
    <div class="flex xs12">
      <va-card title="群组列表">
        <div class="row align--center mb-1">
          <div class="flex md6 xs12">
            <va-button flat disabled color="danger">总计{{totalCount}}条结果</va-button>
          </div>
          <div class="flex xs12 sm6">
            <div class="d-flex justify--end">
              <va-button color="info" small :to="{ name: 'saveGroup' }">新建群组</va-button>
            </div>
          </div>
        </div>
        <va-data-table
          :fields="fields"
          :data="groups"
          :loading="loading"
          :clickable=false
          @page-selected="listGroup"
          api-mode
          :total-pages="totalPage"
        >
          <template slot="sort" slot-scope="props">
            <va-input
              v-model="props.rowData.sortNum"
              type="number"
              :min="1"
            >
              <va-button slot="append" icon="ion-md-checkmark ion" color="info" small @click="updateSortNum(props.rowData)"></va-button>
            </va-input>
          </template>
          <template slot="name" slot-scope="props">
            <va-button
              :to="{ name: 'listChannel' , params: { groupId: props.rowData.groupId }}"
              color="dark"
              flat
              small
              outline
            >
              {{ props.rowData.name }}
            </va-button>
          </template>
          <template slot="backgroundUrl" slot-scope="props">
            <va-avatar>
              <img :src="props.rowData.backgroundUrl">
            </va-avatar>
          </template>

          <template slot="memberCount" slot-scope="props">
            <va-button
              :to="{ name: 'listGroupMember' , params: { groupId: props.rowData.groupId }}"
              color="dark"
              flat
              small
              outline
            >
              {{props.rowData.memberCount}}
            </va-button>
          </template>
          <template slot="actions" slot-scope="props">
            <va-popover message="编辑" placement="top">
              <va-button flat small color="gray" icon="fa fa-pencil"
                :to='{path:`saveGroup/${props.rowData.id}`}'/>
            </va-popover>
            <va-popover message="删除群组成员" placement="top">
              <va-button flat small color="gray" icon="fa fa-user-times"
                @click="kickoutModal = true; kickoutGroupId = props.rowData.groupId; clickKickout()"/>
            </va-popover>
          </template>
        </va-data-table>
        <va-modal v-model="kickoutModal" title="删除群组成员"
          okText="提交" position="center" message="请再次确认是否删除群组成员？"
          @ok="confirmKickout">
          <va-select
            v-model="kickoutGroupUid"
            label="请选择用户名"
            textBy="nickname"
            :options="groupUserNicknames"
            searchable
            width="350px"
          />
        </va-modal>
      </va-card>
    </div>
  </div>
</template>

<script>

import groupApi from '../../api/group'

export default {
  data () {
    return {
      message: ['Required field'],
      groups: [],
      loading: true,
      kickoutModal: false,
      kickoutGroupUid: [],
      kickoutGroupId: null,
      groupUserNicknames: [],
      groupUsers: [],
      totalCount: 0,
      totalPage:null,
    }
  },
  computed: {
    fields () {
      return [
        {
          name: '__slot:sort',
          title: '排序',
          titleClass: 'text-center',
          dataClass: 'text-center',
          width: '10%',
        },
        {
          name: '__slot:backgroundUrl',
          width: '60px',
        },
        {
          name: '__slot:name',
          title: '群组名',
          titleClass: 'text-center',
          dataClass: 'text-center',
          width: '20%',
        },
        {
          name: 'desc',
          title: '描述',
          titleClass: 'text-center',
          dataClass: 'text-center',
          width: '25%',
        },
        {
          name: '__slot:memberCount',
          title: '群组成员',
          titleClass: 'text-center',
          dataClass: 'text-center',
          width: '10%',
        },
        {
          name: '__slot:actions',
          title: '操作',
          titleClass: 'text-center',
          width: '20%',
          dataClass: 'text-center',
        },
      ]
    },
  },
  created () {
    this.listGroup()
  },
  methods: {
    clickKickout () {
      console.log(this.kickoutGroupId)
      this.listGroupUser()
    },
    confirmKickout () {
      // 移除用户出群组
      if (this.kickoutGroupUid == null) {
        return
      }
      const data = {
        uid: this.kickoutGroupUid.id,
        groupId: this.kickoutGroupId,
      }
      groupApi.kickOutGroup(data).then(response => {
        if (response.success === true) {
          this.listGroup()
          // 重置
          this.kickoutGroupUid = []
        }
      }).catch(error => {
        alert(error.msg)
      })
    },
    libaUserNickname () {
      const nicknames = []
      for (let i = 0; i < this.groupUsers.length; i++) {
        const item = {}
        item.id = this.groupUsers[i].uid
        item.nickname = this.groupUsers[i].nickname + ' (' + item.id + ')'
        nicknames.push(item)
      }
      console.log(nicknames)
      this.groupUserNicknames = nicknames
    },
    listGroupUser () {
      if (this.kickoutGroupId == null) {
        return
      }
      groupApi.listGroupUserSimpleInfo(this.kickoutGroupId).then(response => {
        this.groupUsers = response.users
        this.libaUserNickname()
      })
    },
    listGroup(pageNumber = 1) {
      this.loading = true
      const data = {
        pageSize: 20,
        pageNumber: pageNumber,
      }
      groupApi.listGroup(data)
        .then(response => {
          console.log(response)
          this.groups = response.groups
          this.totalCount = response.totalCount
          this.totalPage = response.totalPage
          console.log(this.groups)
          this.loading = false
        })
    },
    computeStatus: function (status) {
      const data = {
        color: 'success',
        text: '付费',
      }
      if (status === 1) {
        data.color = 'danger'
        data.text = '普通'
      }
      return data
    },
    updateSortNum: function (params) {
      if (params.sortNum === null) {
        return
      }
      const data = {
        sortNum: params.sortNum,
      }
      groupApi.updateGroupSortNum(params.id, data).then(response => {
        if (response.success === true) {
          this.showToast('更新排序成功', {
            duration: 1000,
            icon: 'fa-success',
            position: 'top-center',
            fullWidth: false,
          })
          this.listGroup()
        }
      }).catch(error => {
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    },
  },
}

</script>
